import PayoutForm from './payout-card';
import CheckingForm from './checking-form';
import EftForm from './eft-form';
import CreditForm from './credit-card';

import {
  PAYOUT_CARD_FORM,
  PAYOUT_ACH_CHECKING_FORM,
  PAYOUT_ACH_SAVINGS_FORM,
  PAYOUT_EFT_CHECKING_FORM,
  PAYOUT_EFT_SAVINGS_FORM,
  REFUND_CARD_FORM,
} from '../../constants';

import Forms from 'webapp-common-ui/src/reducers/forms';

Forms.addForm(PAYOUT_CARD_FORM, PayoutForm);
Forms.addForm(PAYOUT_ACH_CHECKING_FORM, CheckingForm);
Forms.addForm(PAYOUT_ACH_SAVINGS_FORM, CheckingForm);
Forms.addForm(PAYOUT_EFT_CHECKING_FORM, EftForm);
Forms.addForm(PAYOUT_EFT_SAVINGS_FORM, EftForm);
Forms.addForm(REFUND_CARD_FORM, CreditForm);

Forms.PayoutForm = PayoutForm;
Forms.CheckingForm = CheckingForm;
Forms.EftForm = EftForm;
Forms.CreditForm = CreditForm;

export default Forms;
